import styled from 'styled-components';
import { colours } from 'themes/default';

export const StyledAssistedPassengerSelection = styled.div`
  background-color: ${colours.Greyscale.MistGrey};
  padding: 16px;
  margin: 8px 0;
  border-radius: 6px;
`;

export const RadioButtonLegend = styled.p`
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
`;

export const RadioButtonInfo = styled.p`
  font-size: 1rem;
  margin-top: 0;
  font-weight: normal;
  color: ${colours.Greyscale.CharcoalGrey};
`;
